<template>
  <IconListItem icon="id" :label="label ?? $t('common.words.orderid')">
    {{ id }}
  </IconListItem>
</template>

<script lang="ts" setup>
type IconListItemIdProps = {
  id?: Maybe<string>
  label?: string
}

defineProps<IconListItemIdProps>()
</script>
